import Vue from 'vue'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import Scrollspy from 'vue2-scrollspy';

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import { Drag, Drop } from 'vue-drag-drop';

Vue.config.productionTip = false
Vue.use(BootstrapVue);
Vue.use(Scrollspy);
 
Vue.component('drag', Drag);
Vue.component('drop', Drop);

new Vue({
  render: h => h(App),
}).$mount('#app')
